import { render, staticRenderFns } from "./singleFileUpload.vue?vue&type=template&id=c70d7782&scoped=true&"
import script from "./singleFileUpload.vue?vue&type=script&lang=js&"
export * from "./singleFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./singleFileUpload.vue?vue&type=style&index=0&id=c70d7782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70d7782",
  null
  
)

export default component.exports